import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { WARRANTY_STATUS } from '../../../data/mappers/warrantyMapper';

const EMPTY_VALUE = '—';

const STATUS_VIEW = {
  [WARRANTY_STATUS.ACTIVE]: { style: 'status-active', label: 'warrantyLookup.statusActive' },
  [WARRANTY_STATUS.EXPIRED]: { style: 'status-expired', label: 'warrantyLookup.statusExpired' },
  [WARRANTY_STATUS.INVALIDATED]: { style: 'status-invalidated', label: 'warrantyLookup.statusInvalidated' },
};

// data đã qua data/mappers/warrantyMapper.js — mọi field có thể null trừ serial/productName/status.
const WarrantyInfoSuccess = ({ data }) => {
  const { t } = useTranslation();

  // BE thêm trạng thái mới mà FE chưa biết thì vẫn hiện thẳng giá trị enum, chỉ là không có chấm màu
  // riêng — thà lộ ra là thiếu ánh xạ còn hơn để trống hoặc đoán sai.
  const statusView = STATUS_VIEW[data.status];

  // Đơn vị không phải lúc nào cũng là tháng (BE trả cả ngày/năm) nên không quy đổi, chỉ đổi chữ.
  // defaultValue: đơn vị lạ thì in nguyên enum thay vì in ra tên khoá i18n.
  const warrantyPeriod =
    data.warrantyPeriod &&
    `${data.warrantyPeriod.value} ${t(`warrantyLookup.periodUnit.${data.warrantyPeriod.unit}`, {
      defaultValue: data.warrantyPeriod.unit,
    })}`;

  const rows = [
    { label: t('warrantyLookup.fields.product'), value: data.productName },
    { label: t('warrantyLookup.fields.serial'), value: data.serial },
    { label: t('warrantyLookup.fields.sku'), value: data.sku },
    { label: t('warrantyLookup.fields.manufacturer'), value: data.manufacturer },
    { label: t('warrantyLookup.fields.warrantyPeriod'), value: warrantyPeriod },
    { label: t('warrantyLookup.fields.purchaseDate'), value: data.purchaseDate },
    { label: t('warrantyLookup.fields.expiryDate'), value: data.expiryDate },
    {
      label: t('warrantyLookup.fields.status'),
      value: statusView ? (
        <span className={styles[statusView.style]}>
          <span className={styles['status-dot']} />
          {t(statusView.label)}
        </span>
      ) : (
        data.status
      ),
    },
  ];

  return (
    <>
      <div className={styles['container']}>
        {rows.map(({ label, value }) => (
          <div className={styles['row']} key={label}>
            <div className={styles['label']}>{label}</div>
            <div className={styles['value']}>{value || EMPTY_VALUE}</div>
          </div>
        ))}
      </div>
      {/* Phiếu bị huỷ thì chỉ đọc "Không còn hiệu lực" là không biết làm gì tiếp, nên chỉ vào hotline. */}
      {data.status === WARRANTY_STATUS.INVALIDATED && (
        <div className={styles['invalidated-hint']}>
          <Trans
            i18nKey="warrantyLookup.invalidatedHint"
            // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans bơm số hotline vào làm nội dung thẻ
            components={{ hotline: <a href="tel:+84945416666" /> }}
          />
        </div>
      )}
    </>
  );
};

export default WarrantyInfoSuccess;
